import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const LastModifiedSinceOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.LastModifiedSinceDate.toString()}-30`,
    value: '30',
    displayName: '30 Days',
    categoryName: FilterTypesEnum.LastModifiedSinceDate.toString(),
    filterType: FilterTypesEnum.LastModifiedSinceDate,
  },
];
